import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('MailTemplates?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('MailTemplates/show/'+id);
    },    
    create(params) {
        return Service().post('MailTemplates/create', params);
    },
    update(id, params) {
        return Service().post('MailTemplates/update/'+id, params);
    },
    delete(id) {
        return Service().post('MailTemplates/delete/'+id);
    }
}